import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ListComponent = LoadComponentWithRetry(() => import('./ListProjectsPage'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={path} component={ListComponent} />
    </Switch>
  );
};

export default Routes;
